import type { AccordionTabProps } from '../Accordion'

const faqData: Array<AccordionTabProps> = [
  {
    id: `faq-sc-difference`,
    title: `What's the difference between a secured credit card and an unsecured credit card?`,
    content: `A secured credit card requires a security deposit to open the account, unlike a traditional (or unsecured) credit card. After opening the account, you'd use a secured card just as you'd use any other credit card. We'll evaluate the account for a line increase in as few as 7 months, with no additional deposit required. If you close your account with a zero balance, we'll refund your security deposit.`,
  },
  {
    id: `faq-sc-whats-deposit`,
    title: `What's a security deposit?`,
    content: `If you open a secured credit card account, you'll provide us with funds that we hold as collateral for charges made on the secured card while the account is open. The funds you provide are known as your security deposit. We'll keep the security deposit in a separate bank account maintained by the bank. If you graduate to an unsecured card or close your account with a zero balance, we'll refund your security deposit.`,
  },
  {
    id: `faq-sc-make-deposit`,
    title: `How do I make my security deposit?`,
    content: `If approved, you'll need to use a debit card to make your security deposit within 30 days of approval for a secured credit card. You can use a traditional debit card or a prepaid debit card to make the payment. We'll keep your security deposit in a separate, secure bank account held by the bank.`,
  },
  {
    id: `faq-sc-pay-deposit`,
    title: `Can I pay my security deposit by check or over the phone?`,
    content: `No, the security deposit can only be provided online using either a debit card or prepaid debit card.`,
  },
  {
    id: `faq-sc-apply-deposit`,
    title: `Do I have to make the deposit when I apply?`,
    content: `No, you have 30 days from the date of approval to make your security deposit. If we don't receive your security deposit within 30 days, we'll consider your application withdrawn.`,
  },
  {
    id: `faq-sc-limit-deposit`,
    title: `Does my security deposit determine my credit limit?`,
    content: `No, your credit limit depends on a number of factors, including your credit history. Depending on these factors, your initial credit limit may be equal to or higher than your security deposit. We don't currently offer the option to pay a higher deposit in order to receive a higher credit limit.`,
  },
  {
    id: `faq-sc-return-deposit`,
    title: `Will I get my security deposit back?`,
    content: `We'll refund your security deposit if you graduate to an unsecured card or if you close your account with a zero balance. If you close your account with a non-zero balance or charge off by missing 7 minimum payments in a row, we'll use your security deposit to offset the balance and refund any of the remaining security deposit once the balance is paid.`,
  },
]

export default faqData
